"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    items: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        text: zod_1.z.string(),
        checked: zod_1.z.boolean().optional(),
    }))
        .min(1, "Must have at least one item."),
});
const dataSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        text: zod_1.z.string(),
        checked: zod_1.z.boolean((0, validation_1.labelZodErrors)("Item")),
    })),
});
exports.default = new ItemDefinition_1.ItemDefinition("SingleSelect", configSchema, dataSchema, new validation_1.ValidatorPipeline("SingleSelect Config Validator", [
    new validation_1.Validator("Has at least one sub item configured", (item) => {
        const hasAtLeastOneSubItemWithText = item.config.items.some((subItem) => {
            return subItem.text.trim().length > 0;
        });
        return hasAtLeastOneSubItemWithText
            ? []
            : [
                {
                    errorCode: "MULTI_SELECT",
                    path: ["data", "items"],
                    message: "At least one item must be provided.",
                },
            ];
    }),
]), new validation_1.ValidatorPipeline("SingleSelect Data Validator", [
    new validation_1.Validator("SingleSelect only one", (item) => {
        const totalChecked = item.config.items.reduce((acc, subItem) => {
            const isChecked = item.data.items.find((dataItem) => dataItem.id === subItem.id)?.checked;
            if (isChecked) {
                return acc + 1;
            }
            return acc;
        }, 0);
        return totalChecked === 1
            ? []
            : [
                {
                    errorCode: "SINGLE_SELECT",
                    path: ["data", "items"],
                    message: "Only one item can be selected.",
                },
            ];
    }),
]));
//# sourceMappingURL=SingleSelect.js.map